"use client";

import React, { useEffect, useState } from "react";
import "./join.css";
import "./join2.css";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { fetchAPI } from "../../utils/api";
import {
  accountTypesRes,
  banksListRes,
  countriesRes,
  provincesRes,
  citiesRes,
  officesRes,
} from "../finder/data";
import { phoneCodes } from "../../utils/phoneCodes";
import jwt from "jsonwebtoken";
import { useRouter, useSearchParams } from "next/navigation";
import dayjs from "dayjs";
import CryptoJS from "crypto-js";
import { FaExternalLinkAlt } from "react-icons/fa";
import { type } from "os";

function SignUpForm() {
  // set timezone to UTC+2 (Central Africa Time)
  const timeZone = Intl.DateTimeFormat(
    "en-US",
    { timeZoneName: "short" },
    { timeZone: "Africa/Johannesburg" }
  );
  // Add a state variable to manage the current step of the form
  const [currentStep, setCurrentStep] = useState(1);
  const [title, setTitle] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [idType, setIdType] = useState("RSA ID number");
  const [country, setCountry] = useState("");
  const [OPCNumber, setOPCNumber] = useState("");
  const [consultantNumber, setConsultantNumber] = useState("");
  const [managerNumber, setManagerNumber] = useState("");
  const [city, setCity] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [passportNumber, setPassportNumber] = useState("");
  const [province, setProvince] = useState("");
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [physicalAddress1, setPhysicalAddress1] = useState("");
  const [physicalAddress2, setPhysicalAddress2] = useState("");
  const [office, setOffice] = useState("");
  const [code1, setCode1] = useState("+27");
  const [code2, setCode2] = useState("+27");
  const [cellphoneNumber, setCellphoneNumber] = useState("");
  const [alternativeCellphone, setAlternativeCellphone] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [accountType, setAccountType] = useState({ Id: "", name: "" });
  const [bank, setBank] = useState({ Id: "", name: "" });
  const [memberTypeID, setMemberTypeID] = useState(0);
  // State variable for radio button
  const [assistedByConsultant, setAssistedByConsultant] = useState(false);
  const [offices, setOffices] = useState([]);
  const [memberTypes, setMemberTypes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [banks, setBanks] = useState([]);
  const [accountTypes, setAccountTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isAdumoStatus, setIsAdumoStatus] = useState("");
  const [adumoMessage, setAdumoMessage] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [onceOffFee, setOnceOffFee] = useState("250");
  const [annualFee, setAnnualFee] = useState("195");
  const [selectedMembershipFee, setSelectedMembershipFee] = useState(1);

  // Step 2 states (only include state that doesn't overlap with Step 1)
  const [selectedOnceOffValue, setSelectedOnceOffValue] = useState("option1");
  const [selectedAnnualValue, setSelectedAnnualValue] = useState("option2");
  const [hasAgreed, setHasAgreed] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [isActive2, setIsActive2] = useState(false);
  const [retryLoader, setRetryLoader] = useState(false);
  const [hasToSendPaymentLink, setHasToSendPaymentLink] = useState(false);
  const [paymentLinkEmail, setPaymentLinkEmail] = useState("");
  const [paymentLinkConfirmEmail, setPaymentLinkConfirmEmail] = useState("");
  const [paymentLinkCode, setPaymentLinkCode] = useState("+27");
  const [paymentLinkPhone, setPaymentLinkPhone] = useState("");

  const router = useRouter();
  const params = useSearchParams();

  const encryptedAdumoPayload = params.get("payload");

  const step1Validation = () => {
    // Function to check if all Step 1 fields are filled in
    if (title.trim() === "") {
      alert("Please select a title.");
    } else if (firstName.trim() === "") {
      alert("Please enter a first name.");
    } else if (lastName.trim() === "") {
      alert("Please enter a last name.");
    } else if (idType.trim() === "") {
      alert("Please select an ID type.");
    } else if (idNumber.trim() === "" && idType === "RSA ID number") {
      alert("Please enter an ID number.");
    } else if (passportNumber.trim() === "" && idType === "passport number") {
      alert("Please enter a passport number.");
    } else if (email.trim() === "" || !email.includes("@")) {
      alert("Please enter a valid email address.");
    } else if (confirmEmail.trim() === "") {
      alert("Please confirm your email address.");
    } else if (confirmEmail.trim() !== "" && confirmEmail !== email) {
      alert("Emails do not match.");
    } else if (idType === "RSA ID number" && idNumber.trim().length !== 13) {
      alert("ID number should be 13 numerics.");
    } else if (code1.trim() === "+27" && !/^(0\d{9})$/.test(cellphoneNumber)) {
      alert("Please enter a valid phone number.");
    } else if (
      alternativeCellphone.trim() !== "" &&
      code2.trim() === "+27" &&
      !/^(0\d{9})$/.test(alternativeCellphone)
    ) {
      alert("Please enter a valid alternative phone number.");
    } else if (
      physicalAddress1.trim() === "" ||
      physicalAddress2.trim() === ""
    ) {
      alert("Please enter both physical addresses.");
    } else if (!country || !province || !city) {
      alert("Please fill in province and city.");
    } else if (assistedByConsultant && !office) {
      alert("Please select an office name.");
    } else {
      return true;
    }
    return false;
  };

  const step2Validation = () => {
    if (!startDate) {
      alert("Please select a start date.");
    } else if (!hasAgreed) {
      alert("Please agree to the terms and conditions.");
    } else {
      return true;
    }

    return false;
  };

  const step3Validation = () => {
    if (selectedAnnualValue === "option3" && !accountHolderName) {
      alert("Please enter an account holder name.");
      return false;
    }

    if (selectedAnnualValue === "option3" && !accountNumber) {
      alert("Please enter an account number.");
      return false;
    }

    // if account number is not digits, return false
    if (selectedAnnualValue === "option3" && !/^\d+$/.test(accountNumber)) {
      alert("Account number should be digits only.");
      return false;
    }

    if (!accountType.Id || !bank.Id) {
      alert("Please select an account type and bank.");
      return false;
    }

    return true;
  };

  useEffect(() => {
    if (params.get("payment-result")) {
      setCurrentStep(4);
      setIsAdumoStatus(params.get("payment-result"));

      if (params.get("payment-result") === "failed") {
        setAdumoMessage(params.get("message"));
      }

      if (params.get("payment-result") === "success") {
        window.sessionStorage.removeItem("adumo-payment-retry-object");
      }

      if (params.get("payment-result") === "pending_approval") {
        // Decrypt the data
        const bytes = CryptoJS.AES.decrypt(
          decodeURIComponent(encryptedAdumoPayload),
          process.env.NEXT_PUBLIC_FLP_PAYLOAD_SECRET_KEY
        );
        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

        fetchAPI("/CCPaymentReturnAdumo", "POST", decryptedData)
          .then((res) => {
            setCurrentStep(4);
            setIsAdumoStatus("success");
            typeof window !== "undefined" &&
              window.sessionStorage.removeItem("adumo-payment-retry-object");
          })
          .catch((err) => console.log(err));
      }
    }
  }, [params]);

  useEffect(() => {
    setBanks([]);
    setProvinces([]);
    setAccountTypes([]);

    countriesRes
      .then((res) => {
        if (res?.Data) {
          setCountries(res.Data);
          setCountry(res.Data.find((c) => c.name === "South Africa"));
        }
      })
      .catch((error) => {
        console.log(error);
      });

    banksListRes
      .then((res) => {
        if (res?.Data) {
          setBanks(res.Data);
          setBank(res.Data[2]);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    accountTypesRes
      .then((res) => {
        if (res?.Data) {
          setAccountTypes(res.Data);
          setAccountType(res.Data[2]);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    officesRes
      .then((res) => {
        if (res?.Data) {
          setOffices(res.Data);
          setOffice(
            res.Data.find(
              (office) => office.name === "First Leisure Website – Ekko"
            )?.Id
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (country) {
      provincesRes(country.Id || country)
        .then((res) => {
          if (res?.Data?.length > 0) {
            setProvinces(res.Data);
            setProvince(res.Data[0]?.Id);
          } else {
            setProvince("");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [country]);

  useEffect(() => {
    if (province) {
      citiesRes(province.Id || province)
        .then((res) => {
          if (res?.Data) {
            setCities(res.Data);
            setCity(res.Data[0]?.ID);
          } else {
            setCity("");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [province]);

  // Function to dynamically change the label for ID input based on the selected ID type
  const getIdInputLabel = () => {
    if (idType === "RSA ID number") {
      return "RSA ID Number:";
    } else if (idType === "passport number") {
      return "Passport Number:";
    }
    return "RSA ID Number:";
  };

  const showConsultantFields = () => {
    if (assistedByConsultant) {
      return (
        <>
          <section>
            <div className="form-item fi-30">
              <label>OPC Number:</label>
              <input
                type="text"
                value={OPCNumber}
                onChange={(e) => setOPCNumber(e.target.value)}
              />
            </div>
            <div className="form-item fi-30">
              <label>Consultant Number:</label>
              <input
                type="text"
                value={consultantNumber}
                onChange={(e) => setConsultantNumber(e.target.value)}
              />
            </div>
            <div className="form-item fi-40">
              <label>Manager Number:</label>
              <input
                type="text"
                value={managerNumber}
                onChange={(e) => setManagerNumber(e.target.value)}
              />
            </div>
          </section>
          <section>
            <div className="form-item fi-100">
              <label>Office Name:</label>
              <select
                value={office}
                onChange={(e) => {
                  setOffice(e.target.value);

                  setOnceOffFee(
                    offices.find(
                      (office) =>
                        office.name === "First Leisure Hillcrest - Ekko"
                    )?.Id === +e.target.value
                      ? "195"
                      : "250"
                  );

                  setMemberTypeID(
                    offices.find(
                      (office) =>
                        office.name === "First Leisure Hillcrest - Ekko"
                    )?.Id === +e.target.value
                      ? memberTypes.find(
                          (item) => item.PackageName === "Call Standard"
                        )?.MemberTypeID
                      : memberTypeID
                  );

                  setAnnualFee("195");
                }}
              >
                <option value="" disabled>
                  Select Office Name
                </option>
                {offices.map((option) => (
                  <option key={option.Id} value={option.Id}>
                    {option.name}
                  </option>
                ))}
                {/* Add more office names as needed */}
              </select>
            </div>
          </section>
        </>
      );
    }
    return null;
  };

  const handleClick = () => {
    setIsActive(true);
    setIsActive2(false);

    setOnceOffFee(
      offices.find((item) => item.Id.toString() === office)?.name ===
        "First Leisure Hillcrest - Ekko"
        ? selectedMembershipFee === 1
          ? 195
          : 250
        : onceOffFee
    );
    setSelectedAnnualValue("option2");
  };

  const handleClick2 = () => {
    setIsActive2(true);
    setIsActive(false);
    setSelectedAnnualValue("option3");

    setAnnualFee(
      offices.find((item) => item.Id.toString() === office)?.name ===
        "First Leisure Hillcrest - Ekko"
        ? 195
        : annualFee
    );
  };

  const handleChange = (event) => {
    setSelectedOnceOffValue(event.target.value);
  };

  useEffect(() => {
    fetchAPI("/SignUpPackageType_V2?SystemID=55")
      .then((res) => {
        if (res?.Data?.length > 0) {
          setMemberTypes(res.Data);
          setMemberTypeID(
            res.Data[
              res.Data.findIndex(
                (item) =>
                  item.PackageName ===
                  (offices.find((item) => item.Id.toString() === office)
                    ?.name === "First Leisure Hillcrest - Ekko"
                    ? "Call Standard"
                    : "Outlet Standard")
              )
            ]?.MemberTypeID
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    // smooth scroll to id join-now-form
    const joinNowForm = document.getElementById(`join-now-form${currentStep}`);
    if (joinNowForm) {
      joinNowForm.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [currentStep]);

  // Handle form submission for Step 1
  const handleSubmitStep1 = (e) => {
    e.preventDefault();

    if (!step1Validation()) return;

    setCurrentStep(2);
  };

  // Handle form submission for Step 2
  const handleSubmitStep2 = (e) => {
    e.preventDefault();

    if (!step2Validation()) return;

    if (selectedAnnualValue !== "option3") {
      handleSubmitStep3(e);

      return;
    }

    setCurrentStep(3);
  };

  // Handle form submission for Step 3
  const handleSubmitStep3 = async (e) => {
    e.preventDefault();

    if (!step3Validation()) return;

    if (
      hasToSendPaymentLink &&
      paymentLinkEmail === "" &&
      paymentLinkPhone === ""
    ) {
      alert(
        "Please enter an email address or phone number to send payment link."
      );
      setIsLoading(false);
      return;
    }

    if (
      hasToSendPaymentLink &&
      paymentLinkEmail !== "" &&
      !paymentLinkEmail.includes("@")
    ) {
      alert("Please enter a valid email address.");
      setIsLoading(false);
      return;
    }

    if (
      hasToSendPaymentLink &&
      paymentLinkEmail !== "" &&
      paymentLinkEmail !== paymentLinkConfirmEmail
    ) {
      alert("Emails do not match.");
      setIsLoading(false);
      return;
    }

    if (
      hasToSendPaymentLink &&
      paymentLinkPhone !== "" &&
      !/^(0\d{9})$/.test(paymentLinkPhone)
    ) {
      alert("Please enter a valid phone number.");
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    try {
      // Simulate API call to submit form data
      const response = await fetchAPI("/SignUpMember", "POST", {
        CompanyID: 55,
        MemberTypeID: memberTypeID,
        IsCompany: false,
        Person: {
          Title: title,
          MemberID: 0,
          FirstName: firstName,
          LastName: lastName,
          UsePassport: idType === "passport number",
          IdentityNumber: idType === "RSA ID number" ? idNumber : "",
          PassportNumber: idType === "passport number" ? idNumber : "",
          Email: email,
          Cellphone: cellphoneNumber,
          Telephone: alternativeCellphone,
        },
        Spouse: {
          Title: null,
          FirstName: null,
          LastName: null,
          UsePassport: false,
          IdentityNumber: null,
          PassportNumber: "",
          Email: null,
          Cellphone: null,
          Telephone: null,
        },
        Address: {
          AddressLine1: physicalAddress1,
          AddressLine2: physicalAddress2,
          Country: country.name,
          CountryID: country.Id,
          Province: province.name,
          ProvinceID: province,
          City: city.Name,
          CityID: city,
          PostalCode: +city.PostalCode,
        },
        CompanyName: "",
        CompanyRegsitration: "",
        AssistedSale: assistedByConsultant,
        ConsultantId: +consultantNumber,
        ManagerId: +managerNumber,
        FranchiseBranchID: assistedByConsultant
          ? +office
          : offices.find((item) => item.name === "First Leisure Website – Ekko")
              ?.Id,
        DidReadTerms: hasAgreed,
        AcceptTerms: hasAgreed,
        DepositPercentage: 0,
        InstallmentMonths: 0,
        DepositPaymentDate: dayjs().toISOString().split("T")[0],
        HasDepositDebitOrder: selectedAnnualValue === "option3",
        HasInstallmentDebitOrder: selectedAnnualValue === "option3",
        AnnualPayment:
          !(selectedMembershipFee === 1 || selectedMembershipFee === 3) &&
          selectedAnnualValue === "option3",
        InstallmentPaymentDate: dayjs(startDate)
          .add(1, "day")
          .toISOString()
          .split("T")[0],
        ConvertFromMemberID: null,
        DepositTypeID: 1,
        OpcNumber: OPCNumber,
        UpdateAction: "",
      });

      if (response?.Authenticated) {
        // sign up with credit card
        const virtualResponse = await fetchAPI(
          "/SignUpPaymentRequestMyVirtual",
          "POST",
          {
            ForDO: true,
            DepositTypeID: 1,
            MemberID: response.MemberID,
            CompanyID: 55,
            AccountHolderName: accountHolderName,
            AccountNumber: accountNumber,
            AccountTypeID: accountType.Id,
            BankID: bank.Id,
            HasInstallmentDebitOrder: selectedAnnualValue === "option3",
            NextDebitOrder: dayjs(startDate)
              .add(1, "day")
              .toISOString()
              .split("T")[0],
            SendPaymentLink: hasToSendPaymentLink,
            PaymentLinkEmail: paymentLinkEmail,
            PaymentLinkCellNumber: paymentLinkPhone.startsWith("0")
              ? paymentLinkCode + paymentLinkPhone.slice(1)
              : paymentLinkCode + paymentLinkPhone,
          }
        );

        if (virtualResponse?.Result) {
          if (hasToSendPaymentLink) {
            setCurrentStep(4);
            setIsAdumoStatus("success");
            setAdumoMessage(
              virtualResponse.Message ||
                "Payment link sent successfully. Please follow the instructions in the email that was sent to complete your sign up"
            );
            return;
          }

          handleAdumoPayment(virtualResponse);
          window.sessionStorage.setItem(
            "adumo-payment-retry-object",
            JSON.stringify({
              ForDO: true,
              DepositTypeID: 1,
              MemberID: response.MemberID,
              CompanyID: 55,
              AccountHolderName: accountHolderName,
              AccountNumber: accountNumber,
              AccountTypeID: accountType.Id,
              BankID: bank.Id,
              HasInstallmentDebitOrder: selectedAnnualValue === "option3",
              NextDebitOrder: dayjs(startDate)
                .add(1, "day")
                .toISOString()
                .split("T")[0],
              SendPaymentLink: false,
              PaymentLinkEmail: "",
              PaymentLinkCellNumber: "",
            })
          );
        } else {
          fetchAPI("/RetryPaymentRequestMyVirtual", "POST", {
            ForDO: true,
            DepositTypeID: 1,
            MemberID: response.MemberID,
            CompanyID: 55,
            AccountHolderName: accountHolderName,
            AccountNumber: accountNumber,
            AccountTypeID: accountType.Id,
            BankID: bank.Id,
            HasInstallmentDebitOrder: selectedAnnualValue === "option3",
            NextDebitOrder: dayjs(startDate)
              .add(1, "day")
              .toISOString()
              .split("T")[0],
            SendPaymentLink: hasToSendPaymentLink,
            PaymentLinkEmail: paymentLinkEmail,
            PaymentLinkCellNumber: paymentLinkPhone.startsWith("0")
              ? paymentLinkCode + paymentLinkPhone.slice(1)
              : paymentLinkCode + paymentLinkPhone,
          })
            .then((res) => {
              if (res?.Result) {
                if (hasToSendPaymentLink) {
                  setCurrentStep(4);
                  setIsAdumoStatus("success");
                  setAdumoMessage(
                    res.Message ||
                      "Payment link sent successfully. Please follow the instructions in the email that was sent to complete your sign up"
                  );
                  return;
                }

                handleAdumoPayment(res);

                window.sessionStorage.setItem(
                  "adumo-payment-retry-object",
                  JSON.stringify({
                    ForDO: true,
                    DepositTypeID: 1,
                    MemberID: response.MemberID,
                    CompanyID: 55,
                    AccountHolderName: accountHolderName,
                    AccountNumber: accountNumber,
                    AccountTypeID: accountType.Id,
                    BankID: bank.Id,
                    HasInstallmentDebitOrder: selectedAnnualValue === "option3",
                    NextDebitOrder: dayjs(startDate)
                      .add(1, "day")
                      .toISOString()
                      .split("T")[0],
                    SendPaymentLink: hasToSendPaymentLink,
                    PaymentLinkEmail: paymentLinkEmail,
                    PaymentLinkCellNumber: paymentLinkPhone.startsWith("0")
                      ? paymentLinkCode + paymentLinkPhone.slice(1)
                      : paymentLinkCode + paymentLinkPhone,
                  })
                );
              } else {
                if (hasToSendPaymentLink) {
                  window.sessionStorage.setItem(
                    "adumo-payment-retry-object",
                    JSON.stringify({
                      ForDO: true,
                      DepositTypeID: 1,
                      MemberID: response.MemberID,
                      CompanyID: 55,
                      AccountHolderName: accountHolderName,
                      AccountNumber: accountNumber,
                      AccountTypeID: accountType.Id,
                      BankID: bank.Id,
                      HasInstallmentDebitOrder:
                        selectedAnnualValue === "option3",
                      NextDebitOrder: dayjs(startDate)
                        .add(1, "day")
                        .toISOString()
                        .split("T")[0],
                      SendPaymentLink: true,
                      PaymentLinkEmail: paymentLinkEmail,
                      PaymentLinkCellNumber: paymentLinkPhone.startsWith("0")
                        ? paymentLinkCode + paymentLinkPhone.slice(1)
                        : paymentLinkCode + paymentLinkPhone,
                    })
                  );
                  setCurrentStep(4);
                  setIsAdumoStatus("failed");
                  setAdumoMessage(
                    res.Message ||
                      "Unable to create a payment link. Please try again later"
                  );

                  return;
                }

                alert("Credit card failed to be registered");
              }
              setIsLoading(false);
            })
            .catch((err) => {
              console.log(err);
              setIsLoading(false);
            });
        }
      } else {
        if (response?.status === 500) {
          alert("Something went wrong, please retry.");
        } else {
          alert("Your email already exists in our system.");
        }
        setIsLoading(false);
      }
    } catch (error) {
      if (error?.response?.status === 500) {
        alert(
          error?.response?.data?.Message ||
            "Something went wrong, please retry."
        );
      } else {
        alert("Something went wrong, please retry.");
      }
      setIsLoading(false);
    }
  };

  const handleRetrySignupVirtual = (payload, paymentLink = false) => {
    setRetryLoader(true);
    fetchAPI(
      `/${paymentLink ? "CreatePaymentLink" : "RetryPaymentRequestMyVirtual"}`,
      "POST",
      {
        ForDO: payload?.ForDO,
        DepositTypeID: payload?.DepositTypeID,
        MemberID: payload?.MemberID,
        CompanyID: payload?.CompanyID,
        AccountHolderName: payload?.AccountHolderName,
        AccountNumber: payload?.AccountNumber,
        AccountTypeID: payload?.AccountTypeID,
        BankID: payload?.BankID,
        HasInstallmentDebitOrder: payload?.HasInstallmentDebitOrder,
        NextDebitOrder: payload?.NextDebitOrder,
        SendPaymentLink: payload?.SendPaymentLink,
        PaymentLinkEmail: payload?.PaymentLinkEmail,
        PaymentLinkCellNumber: payload?.PaymentLinkCellNumber,
      }
    )
      .then((res) => {
        if (res?.Result) {
          handleAdumoPayment(res);
          window.sessionStorage.setItem(
            "adumo-payment-retry-object",
            JSON.stringify(payload)
          );
          setRetryLoader(false);
        } else {
          setRetryLoader(false);
          alert("Credit card failed to be registered");
        }
      })
      .catch((err) => {
        console.log(err);
        setRetryLoader(false);
      });
  };

  const handleAdumoPayment = async (virtualResponse) => {
    const payload = {
      iss: virtualResponse?.Data?.CO_ID,
      cuid: virtualResponse?.Data?.MerchantIdReference,
      auid: virtualResponse?.Data?.ApplicationIdReference,
      amount: virtualResponse?.Data?.CC_Amount,
      mref: virtualResponse?.Data?.Reference,
      iat: Date.now() / 1000 - 60,
      exp: Date.now() / 1000 + 600,
    };

    // Generate the JWT token with your payload
    const token = jwt.sign(payload, virtualResponse?.Data?.Jti);

    // send data to adumo for payment
    const formData = new FormData();
    formData.append("frequency", virtualResponse?.Data?.frequency);
    formData.append("collectionDay", virtualResponse?.Data?.collectionDay);
    formData.append("accountNumber", virtualResponse?.Data?.accountNumber);
    formData.append("startDate", virtualResponse?.Data?.startDate);
    formData.append("endDate", virtualResponse?.Data?.endDate);
    formData.append("collectionValue", virtualResponse?.Data?.collectionValue);
    formData.append("contactNumber", virtualResponse?.Data?.contactNumber);
    formData.append("mobileNumber", virtualResponse?.Data?.mobileNumber);
    formData.append("emailAddress", virtualResponse?.Data?.emailAddress);
    formData.append("shouldSendSms", virtualResponse?.Data?.shouldSendSms);
    formData.append("shouldSendEmail", virtualResponse?.Data?.shouldSendEmail);
    formData.append("MerchantID", virtualResponse?.Data?.MerchantIdReference);
    formData.append(
      "ApplicationID",
      virtualResponse?.Data?.ApplicationIdReference
    );
    formData.append("MerchantReference", virtualResponse?.Data?.Reference);
    formData.append("Token", token);
    formData.append("Amount", virtualResponse?.Data?.CC_Amount);
    formData.append("puid", virtualResponse?.Data?.puid);
    formData.append("RedirectSuccessfulURL", virtualResponse?.Data?.SuccessUrl);
    formData.append("RedirectFailedURL", virtualResponse?.Data?.FailureUrl);
    formData.append("DisplayPrice", virtualResponse?.Data?.CC_Amount);
    formData.append("txtCurrencyCode", "ZAR");

    fetch(`${process.env.NEXT_PUBLIC_PROXY_URL}/adumo-payment`, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (typeof window !== "undefined") {
          window.location.replace(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Render the appropriate form step based on the currentStep state
  if (currentStep === 1) {
    return (
      <section className="section-bg" id="join-now-form1">
        <div className="join-cont">
          <div className="count-cont">
            <span className="active">01</span>
            <span
              onClick={() => {
                if (!step1Validation()) return;

                setCurrentStep(2);
              }}
            >
              02
            </span>
            <span
              onClick={() => {
                if (!step1Validation()) return;

                setCurrentStep(3);
              }}
            >
              03
            </span>
          </div>
          <div className="join-head-cont">
            <h2 style={{ fontSize: "1.8em" }}>Membership Details</h2>
          </div>
          <form onSubmit={handleSubmitStep1}>
            <section>
              <div className="form-item mt fi-20">
                <label>Title:</label>
                <select
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                >
                  <option value="">Select Title</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Dr">Dr</option>
                  <option value="Ms">Ms</option>
                </select>
              </div>
              <div className="form-item  mfn fi-40">
                <label>First Name:</label>
                <input
                  type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
              <div className="form-item mln fi-40">
                <label>Last Name:</label>
                <input
                  type="text"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </section>
            <section>
              <div className="form-item fi-60">
                <label>ID Type:</label>
                <select
                  value={idType}
                  onChange={(e) => setIdType(e.target.value)}
                >
                  <option value="RSA ID number">RSA ID number</option>
                  <option value="passport number">passport number</option>
                </select>
              </div>
              <div className="form-item fi-40">
                <label>{getIdInputLabel()}</label>
                <input
                  type={idType === "RSA ID number" ? "number" : "text"}
                  value={idType === "RSA ID number" ? idNumber : passportNumber}
                  onChange={(e) =>
                    idType === "RSA ID number"
                      ? setIdNumber(e.target.value)
                      : setPassportNumber(e.target.value)
                  }
                  minLength={idType === "RSA ID number" ? 13 : 0}
                />
              </div>
            </section>
            <section>
              <div className="form-item fi-60">
                <label>Email Address:</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="form-item fi-10">
                <label>Code:</label>
                <select
                  value={code1}
                  onChange={(e) => setCode1(e.target.value)}
                  className="no-spinners"
                >
                  {phoneCodes.map((option, index) => (
                    <option key={index} value={option.code}>
                      {`${option.country} (${option.code})`}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-item fi-30">
                <label>Cellphone Number:</label>
                <input
                  type="tel"
                  value={cellphoneNumber}
                  onChange={(e) => setCellphoneNumber(e.target.value)}
                />
              </div>
            </section>
            <section>
              <div className="form-item fi-60">
                <label>Confirm Email Address:</label>
                <input
                  type="email"
                  value={confirmEmail}
                  onChange={(e) => setConfirmEmail(e.target.value)}
                  onPaste={(e) => e.preventDefault()}
                  autoComplete="off"
                />
              </div>
              <div className="form-item fi-10">
                <label>Code:</label>
                <select
                  value={code2}
                  onChange={(e) => setCode2(e.target.value)}
                  className="no-spinners"
                >
                  {phoneCodes.map((option, index) => (
                    <option key={index} value={option.code}>
                      {`${option.country} (${option.code})`}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-item fi-30">
                <label>Alternative Cellphone Number:</label>
                <input
                  type="tel"
                  value={alternativeCellphone}
                  onChange={(e) => setAlternativeCellphone(e.target.value)}
                />
              </div>
            </section>
            <section>
              <div className="form-item fi-100">
                <label>Physical Address Line 1:</label>
                <input
                  type="text"
                  value={physicalAddress1}
                  onChange={(e) => setPhysicalAddress1(e.target.value)}
                />
              </div>
            </section>
            <section>
              <div className="form-item fi-100">
                <label>Physical Address Line 2:</label>
                <input
                  type="text"
                  value={physicalAddress2}
                  onChange={(e) => setPhysicalAddress2(e.target.value)}
                />
              </div>
            </section>
            <section>
              <div className="form-item fi-60">
                <label>Country:</label>
                <select
                  value={country.Id}
                  onChange={(e) => {
                    setCountry(e.target.value);
                    // if country is South Africa, reset provinces and cities
                    if (
                      +e.target.value !==
                      countries.find((c) => c.name === "South Africa")?.Id
                    ) {
                      setProvince("");
                      setCity("");
                    }
                  }}
                >
                  <option value="">Select Country</option>
                  {countries.map((option, index) => (
                    <option key={index} value={option.Id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-item fi-40">
                <label>Province:</label>
                {
                  // if country is South Africa, show provinces dropdown, otherwise show input field
                  province !== "" ? (
                    <select
                      value={province}
                      onChange={(e) => setProvince(e.target.value)}
                    >
                      <option value="">Select Province</option>
                      {provinces.map((option, index) => (
                        <option key={index} value={option.Id}>
                          {option.name}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      value={province}
                      onChange={(e) => setProvince(e.target.value)}
                    />
                  )
                }
              </div>
            </section>
            <section>
              <div className="form-item fi-60">
                <label>City/SUBURB:</label>
                {
                  // if country is South Africa, show cities dropdown, otherwise show input field
                  city !== "" ? (
                    <select
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    >
                      <option value="">Select City</option>
                      {cities.map((option, index) => (
                        <option key={index} value={option.ID}>
                          {option.Name}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    />
                  )
                }
              </div>
            </section>
            <section>
              <div className="form-item fi-100 radio">
                <label>Did anyone assist you in making this purchase?</label>
                <div className="assist-radio-cont" width="100%">
                  <label>
                    <input
                      type="radio"
                      name="assistedByConsultant"
                      value={false}
                      checked={!assistedByConsultant}
                      onChange={() => {
                        setAssistedByConsultant(false);
                        setOffice(
                          offices.find(
                            (office) =>
                              office.name === "First Leisure Website – Ekko"
                          )?.Id
                        );
                        setOPCNumber("");
                        setConsultantNumber("");
                        setManagerNumber("");
                      }}
                    />
                    No, I made the purchase myself
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="assistedByConsultant"
                      value={true}
                      checked={assistedByConsultant}
                      onChange={() => setAssistedByConsultant(true)}
                    />
                    Yes, a consultant assisted me
                  </label>
                </div>
              </div>
            </section>
            {showConsultantFields()}
            <div className="btn-cont mobile-btn-cont">
              <button className="btn mobile-btn-join" type="submit">
                SAVE AND PROCEED TO NEXT STEP
              </button>
              <button
                className="btn mobile-btn-join"
                type="button"
                onClick={() => {
                  if (typeof window !== "undefined") window.location.href = "/";
                }}
              >
                CANCEL
              </button>
            </div>
          </form>
        </div>
      </section>
    );
  } else if (currentStep === 2) {
    return (
      <section className="section-bg" id="join-now-form2">
        <div className="join-cont sign-form">
          <div className="count-cont">
            <span
              onClick={() => {
                setCurrentStep(1);
              }}
            >
              01
            </span>
            <span className="active">02</span>
            <span
              onClick={() => {
                if (!step2Validation()) return;

                setCurrentStep(3);
              }}
            >
              03
            </span>
          </div>
          <div className="join-head-cont">
            <h2>PURCHASE AND PAYMENT OPTIONS</h2>
          </div>
          <div className="option-flex-container">
            <div className="item1">
              <div className="package-card">
                <div className="package-card-child">
                  <img
                    style={{ left: "-38px" }}
                    className="package-card-img pcim"
                    src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/flp-standard+with+shape+(1).png"
                  />
                  <div
                    className="package-card-text"
                    style={{ display: "flex" }}
                  >
                    <div>
                      <div
                        className={`package-card-pill ${
                          selectedMembershipFee === 1 ? "memberTypeActive" : ""
                        }`}
                        onClick={() => {
                          setSelectedMembershipFee(1);
                          setMemberTypeID(
                            memberTypes[
                              memberTypes.findIndex(
                                (item) =>
                                  item.PackageName ===
                                  (offices.find(
                                    (item) => item.Id.toString() === office
                                  )?.name === "First Leisure Hillcrest - Ekko"
                                    ? "Call Standard"
                                    : "Outlet Standard")
                              )
                            ]?.MemberTypeID
                          );
                          setOnceOffFee(
                            offices.find(
                              (item) => item.Id.toString() === office
                            )
                              ? offices.find(
                                  (item) => item.Id.toString() === office
                                )?.name === "First Leisure Hillcrest - Ekko"
                                ? "195"
                                : "250"
                              : "250"
                          );
                          setAnnualFee("195");
                          setSelectedAnnualValue("option2");
                          setIsActive(true);
                          setIsActive2(false);
                        }}
                      >
                        R
                        {offices.find((item) => item.Id.toString() === office)
                          ?.name === "First Leisure Hillcrest - Ekko"
                          ? "195"
                          : "250"}{" "}
                        Once Off <br /> R195 Per Month
                      </div>
                      <br />
                      <div>OR</div>
                      <br />
                      <div
                        className={`package-card-pill ${
                          selectedMembershipFee === 2 ? "memberTypeActive" : ""
                        }`}
                        onClick={() => {
                          setSelectedMembershipFee(2);
                          setMemberTypeID(
                            memberTypes[
                              memberTypes.findIndex(
                                (item) =>
                                  item.PackageName ===
                                  (offices.find(
                                    (item) => item.Id.toString() === office
                                  )?.name === "First Leisure Hillcrest - Ekko"
                                    ? "Call Standard"
                                    : "Outlet Standard")
                              )
                            ]?.MemberTypeID
                          );
                          setOnceOffFee("2145");
                          setAnnualFee("2145");
                          setSelectedAnnualValue("option3");
                          setIsActive2(true);
                          setIsActive(false);
                        }}
                      >
                        R2,145 Per Annum
                      </div>
                      <br />
                    </div>
                    <div>
                      <h4>BENIFITS</h4>
                      Flight & Car Hire
                      <br />
                      Tours & Activities
                      <br />
                      Dining & Coffee
                      <br />
                      Deals-4-u
                      <br />
                      Holidays
                      <br />
                      Cruises
                      <br />
                      Movies
                      <br />
                      Spas
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ background: "red" }} className="item2">
              <div className="package-card">
                <div
                  style={{ background: "red" }}
                  className="package-card-child"
                >
                  <img
                    style={{ left: "-38px" }}
                    className="package-card-img pcim"
                    src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/flp-connect+with+shape.png"
                  />
                  <div
                    className="package-card-text"
                    style={{ display: "flex" }}
                  >
                    <div>
                      <div
                        className={`package-card-pill ${
                          selectedMembershipFee === 3 ? "memberTypeActive" : ""
                        }`}
                        onClick={() => {
                          setSelectedMembershipFee(3);
                          setMemberTypeID(
                            memberTypes[
                              memberTypes.findIndex(
                                (item) =>
                                  item.PackageName ===
                                  (offices.find(
                                    (item) => item.Id.toString() === office
                                  )?.name === "First Leisure Hillcrest - Ekko"
                                    ? "Call Connect"
                                    : "Outlet Connect")
                              )
                            ]?.MemberTypeID
                          );
                          setOnceOffFee("250");
                          setAnnualFee("249");
                          setSelectedAnnualValue("option2");
                          setIsActive(true);
                          setIsActive2(false);
                        }}
                      >
                        R{250} Once Off <br /> R{249} Per Month
                      </div>
                      <br />
                      <div>OR</div>
                      <br />
                      <div
                        className={`package-card-pill ${
                          selectedMembershipFee === 4 ? "memberTypeActive" : ""
                        }`}
                        onClick={() => {
                          setSelectedMembershipFee(4);
                          setMemberTypeID(
                            memberTypes[
                              memberTypes.findIndex(
                                (item) =>
                                  item.PackageName ===
                                  (offices.find(
                                    (item) => item.Id.toString() === office
                                  )?.name === "First Leisure Hillcrest - Ekko"
                                    ? "Call Connect"
                                    : "Outlet Connect")
                              )
                            ]?.MemberTypeID
                          );
                          setOnceOffFee("2739");
                          setAnnualFee("2739");
                          setSelectedAnnualValue("option3");
                          setIsActive2(true);
                          setIsActive(false);
                        }}
                      >
                        R2,739 Per Annum
                      </div>
                      <br />
                      <br />

                      <div
                        className="package-card-pill"
                        style={{ background: "white", position: "relative" }}
                      >
                        <img
                          className="premium-pill"
                          src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/flp_connect_plus_bg.png"
                          alt=""
                        />
                        <span className="premium-pill-text">PLUS</span>
                        <span style={{ color: "red" }}>
                          R249 Back in <br /> airtime every month
                        </span>
                      </div>

                      <br />
                    </div>
                    <div>
                      <h4>BENIFITS</h4>
                      Flight & Car Hire
                      <br />
                      Tours & Activities
                      <br />
                      Dining & Coffee
                      <br />
                      Deals-4-u
                      <br />
                      Holidays
                      <br />
                      Cruises
                      <br />
                      Movies
                      <br />
                      Spas
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmitStep2}>
            <section>
              <h3>
                MEMBERSHIP SELECTED:{" "}
                <b className="selectedMembership">
                  {selectedMembershipFee === 1 || selectedMembershipFee === 2
                    ? `FLP STANDARD ${
                        selectedMembershipFee === 1 ? "MONTHLY" : "ANNUAL"
                      }`
                    : `FLP CONNECT ${
                        selectedMembershipFee === 3 ? "MONTHLY" : "ANNUAL"
                      }`}
                </b>
              </h3>

              <div className="price-flex-container">
                <h5>ONCE-OFF FEE</h5>
                <div className="item1">
                  <button
                    type="button"
                    className="price-button"
                    style={{ backgroundColor: isActive ? "green" : "white" }}
                    onClick={handleClick}
                  >
                    <div style={{ color: "black" }}>Amount</div>
                    <div style={{ color: "black" }}>
                      R{Number(onceOffFee).toLocaleString("en-US")}
                    </div>
                  </button>
                </div>
                <h5>PAYMENT METHOD</h5>

                <label>
                  <input
                    className="radiomargin"
                    type="radio"
                    name="radioGroup"
                    value="option1"
                    checked={selectedOnceOffValue === "option1"}
                    onChange={handleChange}
                  />
                  CREDIT / DEBIT CARD
                </label>
                <br />

                <h5>
                  {selectedMembershipFee === 1 || selectedMembershipFee === 3
                    ? "MONTHLY"
                    : "ANNUAL"}{" "}
                  FEE
                </h5>
                <div className="item2">
                  <button
                    type="button"
                    className="price-button"
                    style={{ backgroundColor: isActive2 ? "green" : "white" }}
                    onClick={handleClick2}
                  >
                    <div style={{ color: "black" }}>Amount</div>
                    <div style={{ color: "black" }}>
                      R{Number(annualFee).toLocaleString("en-US")}
                    </div>
                  </button>
                </div>
                <h5>PAYMENT METHOD</h5>

                <div className="radio-dual" style={{ gap: "15px" }}>
                  <div className="r1">
                    <label>
                      <input
                        className="radiomargin"
                        type="radio"
                        name="radioGroup2"
                        value="option2"
                        checked={selectedAnnualValue === "option2"}
                        onChange={() => {
                          setSelectedAnnualValue("option2");
                          if (
                            selectedMembershipFee === 1 ||
                            selectedMembershipFee === 3
                          ) {
                            // if office is First Leisure Hillcrest - Ekko
                            if (
                              offices.find(
                                (item) => item.Id.toString() === office
                              )?.name === "First Leisure Hillcrest - Ekko" &&
                              selectedMembershipFee === 1
                            ) {
                              setAnnualFee("195");
                            } else {
                              setAnnualFee(
                                selectedAnnualValue === "option3" &&
                                  (selectedMembershipFee == 1 ||
                                    selectedMembershipFee == 2)
                                  ? "195"
                                  : "250"
                              );
                            }
                          }
                        }}
                        disabled={
                          isActive ||
                          (selectedMembershipFee !== 1 &&
                            selectedMembershipFee !== 3)
                        }
                      />
                      CREDIT / DEBIT CARD
                    </label>
                  </div>
                  <div className="r2">
                    <label>
                      <input
                        className="radiomargin"
                        type="radio"
                        name="radioGroup2"
                        value="option3"
                        checked={selectedAnnualValue === "option3"}
                        onChange={() => {
                          setSelectedAnnualValue("option3");
                          if (selectedMembershipFee === 3) {
                            setAnnualFee("249");
                          }

                          if (selectedMembershipFee === 1) {
                            setAnnualFee("195");
                          }
                        }}
                        disabled={isActive}
                      />
                      DEBIT ORDER
                    </label>
                  </div>
                </div>
              </div>
            </section>
            <br />
            <section className="start-date">
              <div style={{ display: "flex", justifyContent: "centre" }}>
                <div>
                  START DATE
                  <div>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        className="date2"
                        components={["DatePicker"]}
                      >
                        <DatePicker
                          className="date"
                          value={dayjs(startDate)}
                          minDate={dayjs().add(3, "day")}
                          shouldDisableDate={(date) => {
                            return (
                              (selectedAnnualValue === "option3" &&
                                ![1, 15, 25, 28].includes(date.date())) ||
                              !date.isBefore(dayjs().add(45, "day")) ||
                              date.isBefore(dayjs().add(-1, "day"))
                            );
                          }}
                          onChange={(e) => {
                            setStartDate(e);
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>
                  <br />
                </div>
              </div>
            </section>

            <section className="distex">
              <div>
                DISCLOSURE
                <br />
                <br />
                <label>
                  <input
                    className="radiomargin"
                    type="checkbox"
                    onChange={() => setHasAgreed(!hasAgreed)}
                    value={hasAgreed}
                    checked={hasAgreed}
                  />
                  <a href="/terms-of-service" target="_blank">
                    I HEREBY ACCEPT THE TERMS AND CONDITIONS{" "}
                    <FaExternalLinkAlt />
                  </a>
                </label>
              </div>
            </section>

            <section className="distex payment-link">
              <label htmlFor="sendPaymentLink">
                <input
                  className="radiomargin"
                  type="checkbox"
                  id="sendPaymentLink"
                  onChange={() => {
                    setHasToSendPaymentLink(!hasToSendPaymentLink);
                    setPaymentLinkEmail(hasToSendPaymentLink ? "" : email);
                  }}
                  value={hasToSendPaymentLink}
                  checked={hasToSendPaymentLink}
                />
                <span>SEND PAYMENT LINK</span>
              </label>
              {hasToSendPaymentLink && (
                <>
                  <div className="form-item fi-20">
                    <label>Email Address:</label>
                    <input
                      type="email"
                      value={paymentLinkEmail}
                      onChange={(e) => setPaymentLinkEmail(e.target.value)}
                      placeholder="Type your email address here"
                    />
                  </div>
                  <div className="form-item fi-20">
                    <label>Confirm Email Address:</label>
                    <input
                      type="email"
                      value={paymentLinkConfirmEmail}
                      onChange={(e) =>
                        setPaymentLinkConfirmEmail(e.target.value)
                      }
                    />
                  </div>
                  <div className="form-item fi-20">
                    <div className="form-item fi-40">
                      <label>Code:</label>
                      <select
                        value={paymentLinkCode}
                        onChange={(e) => setPaymentLinkCode(e.target.value)}
                        className="no-spinners"
                      >
                        {phoneCodes.map((option, index) => (
                          <option key={index} value={option.code}>
                            {`${option.country} (${option.code})`}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-item fi-60">
                      <label>Cellphone Number:</label>
                      <input
                        type="tel"
                        value={paymentLinkPhone}
                        onChange={(e) => setPaymentLinkPhone(e.target.value)}
                      />
                    </div>
                  </div>
                </>
              )}
            </section>

            <div className="btn-cont mobile-btn-cont">
              <button
                className="btn mobile-btn-join"
                type="submit"
                disabled={isLoading}
              >
                {selectedAnnualValue === "option2"
                  ? isLoading
                    ? "Processing Now..."
                    : "MAKE PAYMENT with CREDIT CARD"
                  : "SAVE AND PROCEED TO NEXT STEP"}
              </button>
              <button
                className="btn mobile-btn-join"
                type="button"
                onClick={() => {
                  if (typeof window !== "undefined") window.location.href = "/";
                }}
              >
                CANCEL
              </button>
            </div>
          </form>
        </div>
      </section>
    );
  } else if (currentStep === 3) {
    return (
      <section className="section-bg" id="join-now-form3">
        <div className="join-cont">
          <div className="count-cont">
            <span
              onClick={() => {
                setCurrentStep(1);
              }}
            >
              01
            </span>
            <span
              onClick={() => {
                setCurrentStep(2);
              }}
            >
              02
            </span>
            <span className="active">03</span>
          </div>
          <div className="join-head-cont">
            <h2>Payment Details</h2>
            <h4>Debit Order Details</h4>
          </div>
          <form onSubmit={handleSubmitStep3}>
            <section>
              <div className="form-item fi-100">
                <label>Account Holder Name</label>
                <input
                  type="text"
                  value={accountHolderName}
                  onChange={(e) => setAccountHolderName(e.target.value)}
                />
              </div>
              <div className="form-item fi-100">
                <label>Account Number</label>
                <input
                  type="number"
                  value={accountNumber}
                  onChange={(e) => setAccountNumber(e.target.value)}
                />
              </div>
            </section>
            <section>
              <div className="form-item fi-50">
                <label>Account Type:</label>
                <select
                  value={accountType.Id}
                  onChange={(e) => {
                    setAccountType(
                      accountTypes.find(
                        (accountType) => accountType.Id === +e.target.value
                      )
                    );
                  }}
                >
                  <option value="" disabled>
                    Please Select
                  </option>
                  {accountTypes.map((option, index) => (
                    <option key={index} value={option.Id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-item fi-50">
                <label>Bank Name:</label>
                <select
                  value={bank.Id}
                  onChange={(e) =>
                    setBank(banks.find((bank) => bank.Id === +e.target.value))
                  }
                >
                  <option value="" disabled>
                    Please Select
                  </option>
                  {banks.map((option, index) => (
                    <option key={index} value={option.Id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
            </section>
            <div className="btn-cont">
              <button className="btn" type="submit" disabled={isLoading}>
                {isLoading
                  ? "Processing Now..."
                  : "MAKE PAYMENT with CREDIT CARD"}
              </button>
            </div>
          </form>
        </div>
      </section>
    );
  } else if (currentStep === 4) {
    if (hasToSendPaymentLink) {
      return (
        <section>
          <div className="join-cont complete unsucessful">
            {isAdumoStatus === "failed" && (
              <div>
                <button
                  className="btn"
                  type="button"
                  onClick={() => {
                    handleRetrySignupVirtual(
                      JSON.parse(
                        window.sessionStorage.getItem(
                          "adumo-payment-retry-object"
                        )
                      ),
                      true
                    );
                  }}
                >
                  Re-Send Payment Link Request
                </button>
              </div>
            )}
            <div className="join-head-cont">
              <h3>
                <em
                  style={{
                    backgroundColor: "yellow",
                    color: "#111",
                    padding: "5px 10px",
                    borderRadius: "5px",
                  }}
                >
                  {adumoMessage}
                </em>
              </h3>
            </div>
            <div className="btn-cont">
              <button
                className="btn back-home-btn"
                type="button"
                onClick={() => {
                  router.push("/");
                }}
              >
                BACK TO HOME
              </button>
            </div>
          </div>
        </section>
      );
    } else {
      if (isAdumoStatus === "failed") {
        return (
          <section>
            <div className="join-cont complete unsucessful">
              <div className="join-head-cont">
                <h2>SIGN UP UNSUCCESSFUL</h2>
              </div>
              <div>
                <button
                  className="btn"
                  type="button"
                  onClick={() => {
                    handleRetrySignupVirtual(
                      JSON.parse(
                        window.sessionStorage.getItem(
                          "adumo-payment-retry-object"
                        )
                      )
                    );
                  }}
                  disabled={retryLoader}
                >
                  {retryLoader ? "Processing Now..." : "RETRY PAYMENT"}
                </button>
              </div>
              <div className="join-head-cont">
                <h3>
                  PAYMENT FAILED:{" "}
                  <em
                    style={{
                      backgroundColor: "yellow",
                      color: "#111",
                      padding: "5px 10px",
                      borderRadius: "5px",
                    }}
                  >
                    {adumoMessage}
                  </em>
                </h3>
              </div>
              <div className="btn-cont">
                <button
                  className="btn back-home-btn"
                  type="button"
                  onClick={() => {
                    router.push("/");
                  }}
                >
                  BACK TO HOME
                </button>
              </div>
            </div>
          </section>
        );
      }

      if (isAdumoStatus === "pending_approval") {
        return (
          // add pending approval section
          <section>
            <div className="join-cont complete unsucessful">
              <div className="join-head-cont">
                <h2>COMPLETING SIGNUP</h2>
              </div>
              <div className="join-head-cont">
                <em>WAIT A BIT WHILE COMPLETING SIGNUP PROCESS...</em>
              </div>
            </div>
          </section>
        );
      }

      return (
        <section>
          <div className="join-cont complete unsucessful">
            <div className="join-head-cont">
              <h2>SIGN UP COMPLETE</h2>
            </div>
            <div className="btn-cont">
              <button
                className="btn back-home-btn"
                type="button"
                onClick={() => {
                  router.push("/");
                }}
              >
                BACK TO HOME
              </button>
            </div>
          </div>
        </section>
      );
    }
  }
}

export default SignUpForm;
